import { API_PATH } from '../constants';
import axios from "axios";
import AuthService from '../lib/AuthService';
let authObj = new AuthService();

let user_id = '';
if(authObj.loggedIn()) {
    user_id = authObj.getProfile().user_id;
}

export  const commonService = {
    sendHttpRequest
}

function sendHttpRequest(URL , data, method) {
    var date = new Date(); var timestamp = date.getTime();

    var params = '';

    if(method === 'GET' && data) {

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var val = data[key];
                params += '&'+key+'='+val;
            }
        }
    }

    if( user_id !=='') {
        axios.get(API_PATH+'login/loglastactivity?user_id='+user_id)
            .then(function (res) {
                // handle success
                authObj.login(res.data.response);
            });
    }


    // Send an HTTP  request
    return axios({
        method: method,
        supportHeaderParams: true,
        url: API_PATH+URL+'?t='+timestamp+params,
        data: data,
        async:false
    }).then(function(res){
        console.log("success");
        if(res.data.response === 'failure' || Object.keys(res.data.response).length === 0) {
            return undefined;
        }
        return res;

    }).catch(function(err){
        console.log("error");
        console.log(err);
        return err;
    });


}



// WEBPACK FOOTER //
// ./src/services/common.services.js